// extracted by mini-css-extract-plugin
export var modalFooter = "_mo-0";